// Detecção de variáveis em templates Meta (WhatsApp Business).
// Espelha backend/services/wa_business/template_components.py: template cujo
// envio exige parâmetros ({{n}} no corpo/cabeçalho, cabeçalho de mídia, botão
// de URL dinâmica ou copy_code) não pode sair pelo envio simples — a Meta
// recusa (132000) ou o texto chega com buraco.

const PLACEHOLDER_RE = /\{\{\s*\w+\s*\}\}/;
const MEDIA_HEADER_FORMATS = ['IMAGE', 'VIDEO', 'DOCUMENT'];

export function templateRequiresParams(template) {
  const comps = template?.components || [];
  for (const c of comps) {
    const type = (c.type || '').toUpperCase();
    if (type === 'HEADER') {
      const fmt = (c.format || 'TEXT').toUpperCase();
      if (MEDIA_HEADER_FORMATS.includes(fmt)) return true;
      if (PLACEHOLDER_RE.test(c.text || '')) return true;
    } else if (type === 'BODY') {
      if (PLACEHOLDER_RE.test(c.text || '')) return true;
    } else if (type === 'BUTTONS') {
      for (const b of c.buttons || []) {
        const bt = (b.type || '').toLowerCase();
        if (bt === 'url' && PLACEHOLDER_RE.test(b.url || '')) return true;
        if (bt === 'copy_code') return true;
      }
    }
  }
  return false;
}

// Motivo curto para tooltip/aviso (selects de fallback que ainda não têm
// formulário de preenchimento).
export const TEMPLATE_PARAMS_HINT =
  'Este template tem variáveis e o preenchimento ainda não está disponível aqui. Escolha um template sem variáveis.';

const POSITIONAL_RE = /\{\{\s*(\d+)\s*\}\}/g;

// {{n}} presentes num texto, ordenados e sem repetição (1-indexado).
export const positionalParamsInText = (text) => {
  const found = new Set();
  for (const m of (text || '').matchAll(POSITIONAL_RE)) found.add(parseInt(m[1], 10));
  return Array.from(found).sort((a, b) => a - b);
};
const positionalParams = positionalParamsInText;

// Espelho de extract_template_variables do backend, para a UI montar o
// formulário de preenchimento.
export function extractTemplateParams(template) {
  const out = { header: null, bodyText: '', bodyParams: [], buttons: [] };
  for (const c of template?.components || []) {
    const type = (c.type || '').toUpperCase();
    if (type === 'HEADER') {
      const fmt = (c.format || 'TEXT').toUpperCase();
      out.header = {
        format: fmt,
        text: c.text || '',
        params: fmt === 'TEXT' ? positionalParams(c.text) : [],
        needsMedia: MEDIA_HEADER_FORMATS.includes(fmt),
      };
    } else if (type === 'BODY') {
      out.bodyText = c.text || '';
      out.bodyParams = positionalParams(c.text);
    } else if (type === 'BUTTONS') {
      (c.buttons || []).forEach((b, index) => {
        const bt = (b.type || '').toLowerCase();
        if ((bt === 'url' && positionalParams(b.url).length) || bt === 'copy_code') {
          out.buttons.push({ index, subType: bt, text: b.text || '', url: b.url || '' });
        }
      });
    }
  }
  return out;
}

// Substitui {{n}} pelos valores (1-indexado) para o preview; sem valor fica
// intacto.
export function fillBodyText(text, values) {
  return (text || '').replace(POSITIONAL_RE, (m, n) => {
    const v = (values || [])[parseInt(n, 10) - 1];
    return v && String(v).trim() ? String(v) : m;
  });
}

export const looksLikePhone = (s) => !!s && /^[\d\s()+-]+$/.test(s);
